import API from "../apis/api";
import { GetInfoResponse, ToTranslateField, } from "../apis/response/GetInfoResponse";
import { Image, useMantineTheme, createStyles } from "@mantine/core";
import { useState, useEffect } from "react";
import { CurrentLocale } from "../App";
import DefaultContainer from "../components/container";
import ImageStorageService from "../services/ImageStorageService";
import { SharedProps } from "../types/shared-props";
import { GetTranslated } from "../types/translate-field";
import { GetNavbarCategoriesReponse, TransformToCategoryMenu } from "../apis/response/GetNavbarCategoriesResponse";
import { GetPortalResponse, ToPortalLink } from "../apis/response/GetPortalResponse";
import { useTranslation } from "react-i18next";

const useStyles = createStyles((theme) => ({
  abouthlsbg: {
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  firsttitle: {
    fontFamily: theme.other.titleFont,
    fontSize: 30,
    color: theme.colors.hkc[1],
    width: '100%',
    paddingBottom: 10
  },
  firsttitleborder: {
    width: 'calc(100% - 20px)',
    borderBottom: `${theme.other.layout.slashHeight}px solid ${theme.colors.hkc[0]}`
  },
  secondtitle: {
    color: theme.colors.offWhite[1],
    marginBottom: 20,
    paddingBottom: 10,
    fontSize: 23,
    fontFamily: theme.other.titleFont,
    borderBottom: `${theme.other.layout.slashHeight}px solid ${theme.colors.hkc[1]}`,
    witdth: '100%'
  },
  firstdescription: {
    display: "flex",
    fontFamily: ["Microsoft Sans Serif"],
    height: 100,
    flexDirection: "column",
    justifyContent: 'space-between',
    alignItems: "start",
    marginLeft: -20,
    marginTop: 20,
    marginBottom: -20,
    padding: 20,
    flexGrow: 1,
    backgroundColor: `${theme.colors.hkc[0]}EE`,
    zIndex: 4,
    [theme.fn.smallerThan("md")]: {
      margin: 0,
      marginBottom: -20,
      padding: '20px 20px 20px 0px'
    },
  },
  phone: {
    color: theme.colors.offWhite[1],
    marginLeft: 20,
    fontSize: 16,
    [theme.fn.smallerThan("md")]: {
      fontSize:13,
    },
  },
  address: {
    height: '100%',
    color: theme.colors.offWhite[1],
    textAlign: "left",
    fontSize: 16,
    flex: 1,
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    fontFamily: ["Microsoft Sans Serif"],
    //fontFamily: ["MSJhengHei", "BerlinSans"],
    [theme.fn.smallerThan("md")]: {
      fontSize:14,
    },
  },
  seconddescription: {
    display: "flex",
    flexDirection: "column",
    alignItems: "end",
    marginLeft: -120,
    marginTop: 80,
    padding: 20,
    flexGrow: 1,
    backgroundColor: "lightgrey",
    zIndex: 4,
    [theme.fn.smallerThan("md")]: {
      display: "none",
    },
  },
  overlayText: {
    fontSize: 40,
    color: "white",
    paddingBottom: 15,
    borderBottom: `10px solid ${theme.colors.hkc[1]}`,
    // width: '50%',
    width: "min(100%, 600px)",
    margin: "auto",
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  locationDiv: {
    display: 'flex',
    flexDirection: "column",
    justifyContent: "space-between",
    padding: 20,
    height: '100%',
    width: 300,
    backgroundColor: `${theme.colors.hkc[0]}EE`,
    zIndex: 5,
    [theme.fn.smallerThan("md")]: {
      width: '100%',
    },
  },
  contactUs: {
    width: '25%',
    backgroundColor: theme.colors.offWhite[0],
    zIndex: 5,
    padding: 20,
    [theme.fn.smallerThan("md")]: {
      width: '100%',
    },
  },
  contactUsDiv: {
    display: "flex",
    flexDirection: "row",
    [theme.fn.smallerThan("md")]: {
      flexDirection: "column",
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(212,243,249, 0.6)",
    padding: '20px 100px',
    [theme.fn.smallerThan("md")]: {
      padding: 20,
    },
  }
}));

interface ContactUsPageProps {
  email_hk?: string;
  sz_office?: string;
  hk_office?: string;
  hk_phone?: string;
  hk_fax?: string;
  bmap?: string;
  plaza?: string;
}

const ContactUs = () => {
  const { classes } = useStyles();
  const theme = useMantineTheme();
  const init: ContactUsPageProps & SharedProps = {}
  const [props, setProps] = useState(init)

  const fetchData = async () => {

    const hkoffice: GetInfoResponse = (await API.Info.GetInfo("html_office_hk"))
      .obj[0];
    const hk_office = GetTranslated(ToTranslateField(hkoffice), CurrentLocale);
    const szoffice: GetInfoResponse = (await API.Info.GetInfo("html_office_sz"))
      .obj[0];
    const sz_office = GetTranslated(ToTranslateField(szoffice), CurrentLocale);
    const phone_hk: GetInfoResponse = (await API.Info.GetInfo("phone_hk")).obj[0];
    const hk_phone = GetTranslated(ToTranslateField(phone_hk), CurrentLocale);
    const fax_hk: GetInfoResponse = (await API.Info.GetInfo("fax_hk")).obj[0];
    const hk_fax = GetTranslated(ToTranslateField(fax_hk), CurrentLocale);
    const hk_mail: GetInfoResponse = (await API.Info.GetInfo("email_hk")).obj[0];
    const email_hk = GetTranslated(ToTranslateField(hk_mail), CurrentLocale);

    const imgService = new ImageStorageService()
    const res: { items: string } = (await API.ImageStorage.Get("baidumap02")).obj;
    const bmap = imgService.FormatImageSrc(res.items);
    const Billion_Plaza: { items: string } = (await API.ImageStorage.Get("Billion Plaza")).obj;
    const plaza = imgService.FormatImageSrc(Billion_Plaza.items);

    const c: GetNavbarCategoriesReponse = (await API.Category.GetNavbarCategories()).obj
    const categories = TransformToCategoryMenu(c.items)
    const usefulRes: GetPortalResponse = (await API.Info.GetUsefulLinks()).obj
    const useful = usefulRes.items.map(x => ToPortalLink(x))

    const newProps = {
      hk_office, sz_office, hk_phone, hk_fax, bmap, plaza, categories, useful, email_hk
    }
    setProps(newProps)

  }

  const aboutus = useTranslation('aboutus');


  useEffect(() => {
    fetchData()
  }, [])
  return (
    <DefaultContainer>
      <div
        className={`${classes.abouthlsbg}`}
        style={{ backgroundImage: `url(${props.plaza})`, backgroundPosition: '0% 25%', }}
      >
        <div className={classes.container}>
          <div className={classes.contactUsDiv}>
            <div className={classes.contactUs}>
              <div className={classes.firsttitle} style={{ textAlign: 'left' }}>{aboutus.t('contact_us')}</div>
              <div className={classes.firsttitleborder}></div>
            </div>
            <div className={classes.firstdescription}>
              <div className={classes.phone} style={{ textAlign: 'left', marginTop: 5 }}>{`${aboutus.t('email')} `}<a href={`mailto: ${props.email_hk}`} style={{ color: '#FFFFFF' }}><u dangerouslySetInnerHTML={{ __html: props.email_hk ?? '' }}></u></a></div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: 'end',
                  width: "100%",
                }}
              >
                <div
                  className={classes.phone}
                  dangerouslySetInnerHTML={{ __html: props.hk_phone ?? '' }}
                  style={{ marginBottom: 5 }}
                />
                <div
                  className={classes.phone}
                  dangerouslySetInnerHTML={{ __html: props.hk_fax ?? '' }}
                  style={{ marginBottom: 5 }}
                />
                <div
                  style={{
                    width: 10,
                    height: 10,
                    backgroundColor: theme.colors.hkc[1],
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </div>
          </div>

          <div style={{ marginTop: 40, display: "flex", flexDirection: "row" }} >
            <div
              className={classes.locationDiv}>
              <div className={classes.secondtitle} style={{ textAlign: 'left' }}>{aboutus.t('location_hk')}</div>
              <div
                className={classes.address}
                dangerouslySetInnerHTML={{ __html: props.hk_office ?? '' }}
              />

            </div>
            <div className={classes.seconddescription}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d922.6134625348723!2d114.15017052986813!3d22.336485785654986!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340407537082011f%3A0x597135b290ceb29c!2sBillion%20Plaza%2C%208%20Cheung%20Yue%20St%2C%20Cheung%20Sha%20Wan!5e0!3m2!1sen!2shk!4v1659070479789!5m2!1sen!2shk"
                width="620px"
                height="300"
                style={{ border: "0", float: "left" }}
                loading="lazy"
              />
            </div>
          </div>

          <div style={{ marginTop: 20, display: "flex", flexDirection: "row", width: '100%' }} >
            <div className={classes.locationDiv}>
              <div className={classes.secondtitle} style={{ textAlign: 'left' }}>{aboutus.t('location_sz')}</div>

              <div
                className={classes.address}
                dangerouslySetInnerHTML={{ __html: props.sz_office ?? '' }}
              />

            </div>
            <div className={classes.seconddescription}>
              <Image src={props.bmap} style={{ width: 620, marginTop: 10 }} />
            </div>
          </div>
        </div>
      </div>
    </DefaultContainer>
  );
};

export default ContactUs;
